export default "__VITE_ASSET__B6bNFC17__"